import { Component, Input, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { NgForm, FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { StripeSource } from "../../models";
import { StripeService, AppSettingsService } from "@oa/shared-core";


import { injectStripe, StripeElementsDirective, StripeCardComponent } from "ngx-stripe";
import { StripeElementsOptions, StripeCardElementOptions, StripeCardElementChangeEvent } from "@stripe/stripe-js";

// import { Stripe } from 'stripe';
@Component({
    selector: "stripe-form",
    templateUrl: "./stripe-form.component.html",
    styleUrls: ["./stripe-form.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, StripeElementsDirective, StripeCardComponent]
})
export class StripeFormComponent {
  private readonly _componentName = "StripeFormComponent";

  // @Input()
  // set source(value: StripeSource) {
  //   this.stripeSource = value;
  //   if (value) {
  //     this.card.name = value.name;
  //     this.cardType = this.stripeService.brandIconCSSClass(value.brand);
  //     if (value.brand === "American Express") {
  //       this.card.number = "****-******-*" + value.last4;
  //       this.card.cvc = "****";
  //     } else {
  //       this.card.number = "****-****-****-" + value.last4;
  //       this.card.cvc = "***";
  //     }
  //     this.card.exp = ("00" + value.expMonth).slice(-2) + "/" + value.expYear.toString().slice(-2);
  //   }
  // }

  @Input() title = "Enter Payment Information";
  @Input() disabled = false;
  @Input() errorMessage: string;

  @ViewChild(NgForm, { static: true }) stripeForm;

  cardType = "";
  card: ICreditCard = {} as ICreditCard;
  inputCardNumber = "";
  wait = false;
  stripeSource: StripeSource;
  captureError = false;

  constructor(readonly router: Router, readonly stripeService: StripeService, readonly appSettingsService: AppSettingsService) {}

  stripe = injectStripe(this.appSettingsService.stripePublicKey);
  elements;

  @ViewChild(StripeCardComponent) cardElement: StripeCardComponent;

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: "#666EE8",
        color: "#31325F",
        fontWeight: "300",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: "18px",
        "::placeholder": {
          color: "#CFD7E0",
        },
      },
    },
  };

  elementsOptions: StripeElementsOptions = {
    locale: "en",
  };

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // console.log(this.expirationDateInputComponent.value);
  }

  public capture(): Observable<StripeSource> {
    if (!this.card.name) {
      this.captureError = true;
      // Send a plain string error for easier unwrapping
      return throwError(new Error("Card name is required"));
    }

    return this.stripe.createToken(this.cardElement.element, { name: this.card.name }).pipe(
      map((result) => {
        if (result.token) {
          const token = result.token;
          return {
            stripeSourceId: token.id,
            last4: token.card.last4,
            brand: token.card.brand,
            expMonth: token.card.exp_month,
            expYear: token.card.exp_year,
            name: token.card.name,
          } as StripeSource;
        } else if (result.error) {
          // Error creating the token
          const message = result.error.message ? result.error.message : "An error occurred submitting your card, please try again.";
          this.errorMessage = message;
          this.wait = false;
          // Send a plain string error for easier unwrapping
          throw new Error(message);
        }
        // Defensive: should not reach here
        throw new Error("Unknown error occurred while creating Stripe token.");
      }),
      catchError((err) => {
        this.errorMessage = err.message || "An error occurred submitting your card, please try again.";
        this.wait = false;
        return throwError(err);
      })
    );
  }

  onChange(event: StripeCardElementChangeEvent) {
    if (event.error) {
      this.errorMessage = event.error.message;
    } else {
      this.errorMessage = null;
    }
  }
}

export interface ICreditCard {
  name: string;
  exp: string;
  cvc: string;
  number: string;
}
